import type { ReactNode } from 'react'
import { cn } from '../lib/cn'

export interface SegmentedOption<T extends string> {
  value: T
  label: string
  icon?: ReactNode
}

export interface SegmentedProps<T extends string> {
  value: T
  onChange: (value: T) => void
  options: SegmentedOption<T>[]
  size?: 'sm' | 'md'
  activeTone?: 'brand' | 'scope'
}

export function Segmented<T extends string>({
  value,
  onChange,
  options,
  size = 'md',
  activeTone = 'brand',
}: SegmentedProps<T>) {
  return (
    <div className="inline-flex rounded-lg bg-neutral-100 p-0.5">
      {options.map((option) => {
        const active = option.value === value
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={cn(
              'inline-flex items-center gap-1.5 rounded-md font-medium transition-colors',
              size === 'sm' ? 'px-2.5 py-1 text-xs' : 'px-3 py-1.5 text-sm',
              active
                ? cn('bg-white shadow-sm', activeTone === 'scope' ? 'text-scope' : 'text-brand-700')
                : 'text-neutral-500 hover:text-neutral-700',
            )}
          >
            {option.icon}
            {option.label}
          </button>
        )
      })}
    </div>
  )
}
